import { css } from '@emotion/react';
import { Skeleton } from '@mui/material';
import { FC } from 'react';
import { GenericFallbacksWrapper } from '../../../components/Fallback/GenericFallbacksWrapper';
import { FrostedGate } from '../../../components/FrostedGate/FrostedGate';
import { IFinanceRoundDataModel } from '../../../data-models/finance-round.data-model';
import { RoundDocumentsPreview } from './RoundDocumentsPreview';
import { RoundDocumentsSection } from './RoundDocumentsSection';
import { RoundGovernancePreview } from './RoundGovernancePreview';
import { RoundGovernanceSection } from './RoundGovernanceSection';
import { RoundOverviewCard } from './RoundOverviewCard';
import { RoundSecurityGrid } from './RoundSecurityGrid';
import { RoundTransactionGrid } from './RoundTransactionGrid';
import { collapsedCardHeight } from './deals-detail.styles';

export const detailStackCss = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

interface DealRoundDetailProps {
  round: IFinanceRoundDataModel;
  companyId: number;
}

/**
 * Right detail pane of the Deals tab for the selected round: Round Overview,
 * Governance, Security Overview, Transaction Overview, and Documents.
 */
export const DealRoundDetail: FC<DealRoundDetailProps> = ({ round, companyId }) => (
  <div css={detailStackCss}>
    {/* Per-round keys remount the cards so collapse state resets with the selection. */}
    <GenericFallbacksWrapper suspenseFallback={<Skeleton variant='rectangular' height={140} />}>
      <RoundOverviewCard key={`overview-${round.id}`} round={round} companyId={companyId} />
    </GenericFallbacksWrapper>
    <GenericFallbacksWrapper
      suspenseFallback={<Skeleton variant='rectangular' height={collapsedCardHeight} />}
    >
      <FrostedGate target='deals.governance' preview={<RoundGovernancePreview />}>
        <RoundGovernanceSection key={`governance-${round.id}`} round={round} companyId={companyId} />
      </FrostedGate>
    </GenericFallbacksWrapper>
    <RoundSecurityGrid key={`security-${round.id}`} round={round} />
    <GenericFallbacksWrapper
      suspenseFallback={<Skeleton variant='rectangular' height={collapsedCardHeight} />}
    >
      <RoundTransactionGrid key={`transaction-${round.id}`} round={round} companyId={companyId} />
    </GenericFallbacksWrapper>
    <FrostedGate target='deals.documents' preview={<RoundDocumentsPreview />}>
      <RoundDocumentsSection key={`documents-${round.id}`} round={round} />
    </FrostedGate>
  </div>
);
